export const toolsFr = {
  title: "Outils",
  subtitle: "Outils pour vous accompagner dans cette piste d'action.",
  loading: "Chargement…",
  error: "Une erreur est survenue.",
  retry: "Réessayer",
  types: {
    guide: "Guide pratique",
    action_sheet: "Fiche d'action",
    video: "Vidéo",
    analysis_grid: "Grille d'analyse",
    other: "Autre",
  },
  directory: {
    heading: "Outils",
    help: "Outils proposés pour cette piste d'action.",
    resultCount_one: "{{count}} outil",
    resultCount_other: "{{count}} outils",
    favoriteCount_one: "{{count}} favori",
    favoriteCount_other: "{{count}} favoris",
    seeMore_one: "Voir {{count}} outil de plus",
    seeMore_other: "Voir {{count}} outils de plus",
    none: "Aucun outil n'est encore disponible pour cette piste d'action.",
    noneFiltered: "Aucun outil ne correspond aux filtres sélectionnés.",
    noFavorites: "Vous n'avez pas encore d'outil favori pour cette piste d'action.",
    seeAll: "Voir tous les outils",
    unavailable: "Les outils ne sont pas disponibles pour cette piste d'action.",
    actionRequired: {
      title: "Sélectionnez une piste d'action",
      help: "Les outils se consultent à partir d'une piste d'action de votre plan d'action.",
      goToPlans: "Aller au plan d'action",
    },
  },
  card: {
    by: "Par {{author}}",
    access: "Accéder à l'outil",
    seeMore: "Voir plus",
    seeLess: "Voir moins",
    favorite: "Ajouter aux favoris",
    unfavorite: "Retirer des favoris",
  },
  filters: {
    sectorsServed: "Secteurs associés",
    companySizes: "Taille des entreprises",
    orgTypes: "Types d'organisation associés",
    heading: "Filtres",
    search: "Titre, auteur…",
    type: "Type d'outil",
    favoritesOnly: "Mes favoris seulement",
  },
  cell: {
    column: "Outils",
    all: "Consulter les outils pour cette piste d'action",
    favorites: "Consulter vos outils favoris pour cette piste d'action",
  },
  admin: {
    title: "Gestion des outils",
    create: "Créer un outil",
    editTool: "Modifier l'outil",
    edit: "Modifier",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    empty: "Aucun outil.",
    countTotal_one: "{{count}} outil au total",
    countTotal_other: "{{count}} outils au total",
    linkChangeToValidate: "À valider",
    linkChangePending: "En attente",
    orderToValidate: "Ordre à valider",
    orderPending: "Ordre en attente",
    import: "Importer des outils",
    importActions: "Importer des associations",
    importHelp: "Téléversez un classeur .xlsx d'outils.",
    importCancelledReviews_one:
      "L'import a annulé 1 révision en cours : {{titles}}.",
    importCancelledReviews_other:
      "L'import a annulé {{count}} révisions en cours : {{titles}}.",
    imported:
      "Import terminé : {{created}} créé(s), {{updated}} mis à jour, {{skipped}} ignoré(s).",
    actionsImported:
      "Import terminé : {{pairs}} association(s) appliquée(s) pour {{tools}} outil(s).",
    created: "Outil créé.",
    updated: "Outil mis à jour.",
    deleted: "Outil supprimé.",
    confirmDelete: "Supprimer cet outil ?",
    history: "Historique",
    actionCount_one: "{{count}} piste d'action",
    actionCount_other: "{{count}} pistes d'action",
    otherToggle: "Autre — précisez",
    status: {
      pending: "En attente",
      unassociated: "Non associé",
      inactive: "Inactif",
      active: "Actif",
    },
    fields: {
      title: "Titre",
      author: "Auteur",
      publicationYear: "Année de parution",
      type: "Type d'outil",
      summary: "Résumé",
      pageChapter: "Page / chapitre",
      resourceUrl: "Lien vers l'outil",
      sectorsServed: "Secteurs desservis",
      companySizes: "Tailles d'entreprise desservies",
      organizationTypes: "Types d'organisation visés",
      sectorsServedOther: "Autres secteurs visés",
      organizationTypesOther: "Autres types d'organisation visés",
      isActive: "Actif",
      isInactive: "Inactif",
      actions: "Pistes d'action associées",
    },
  },
  linkOrder: {
    section: "Ordre des outils par piste d'action",
    sectionHint:
      "Chaque changement d'ordre doit être validé par un autre administrateur.",
    pending: "En attente",
    toValidate: "À valider",
    open: "Ordre des outils ({{count}})",
    title: "Ordre des outils",
    intro:
      "Glissez-déposez pour définir l'ordre d'affichage. Un autre administrateur devra valider le changement.",
    introMine:
      "Vous avez proposé ce changement. Un autre administrateur doit le valider — vous ne pouvez pas valider votre propre proposition.",
    introReview:
      "Vérifiez l'ordre proposé, puis approuvez-le ou faites une contre-proposition.",
    linkChangeWarning:
      "Un changement d'associations est en attente pour cette piste d'action : la liste pourrait encore gagner ou perdre un élément.",
    notVisible: "non visible",
    new: "nouveau",
    was: "était {{n}}",
    proposedBy: "Proposé par {{name}}",
    addedSince: "Ajouté depuis la proposition — placé à la fin",
    note: "Note",
    noteLabel: "Note — requise",
    notePlaceholder: "Justifiez votre contre-proposition…",
    propose: "Proposer l'ordre",
    approve: "Approuver",
    counter: "Contre-proposer",
    submitCounter: "Soumettre la contre-proposition",
    close: "Fermer",
  },
  linkChange: {
    // Parity with the Django back-office: same wording, same split between the
    // list's review modal and the edit form's decision controls.
    awaiting_one:
      "{{count}} outil a un changement de pistes d'action en attente de votre validation.",
    awaiting_other:
      "{{count}} outils ont un changement de pistes d'action en attente de votre validation.",
    openReview: "À valider",
    pendingOnly: "En attente de validation seulement",
    noneAwaiting: "Aucun changement en attente de validation.",
    reviewTitle: "Outils · à valider",
    reviewIntro: "Proposés par d'autres personnes.",
    reviewIntroOwn: "Vous ne pouvez pas valider vos propres propositions.",
    review: "Réviser",
    proposedBy: "Proposé par {{name}}",
    note: "Note",
    noteLabel: "Note — requise",
    notePlaceholder: "Justifiez votre contre-proposition…",
    noDifference: "Aucune différence détectée.",
    count_one: "{{count}} proposition",
    count_other: "{{count}} propositions",
    later: "Plus tard",
    approveAll: "Approuver tout",
    formPendingMine:
      "Vous avez proposé ce changement. Un autre administrateur doit le valider — vous ne pouvez pas valider votre propre proposition.",
    formPendingReview:
      "Vérifiez le changement proposé, puis approuvez-le ou faites une contre-proposition.",
    approve: "Approuver",
    counter: "Contre-proposer",
    cancelCounter: "Annuler la contre-proposition",
    submitCounter: "Soumettre la contre-proposition",
    saveOthers: "Enregistrer les autres champs",
    staged:
      "Le changement de pistes d'action est en attente de validation par un autre administrateur.",
    frozen:
      "Les pistes d'action n'ont pas été modifiées : un changement est déjà en attente de validation.",
    approved: "Changement de pistes d'action approuvé.",
    countered: "Contre-proposition enregistrée, en attente d'une autre personne.",
    noneToApprove: "Aucun changement à approuver.",
    approvedCount_one: "{{count}} changement de pistes d'action approuvé.",
    approvedCount_other: "{{count}} changements de pistes d'action approuvés.",
  },
  picker: {
    newLink: "nouvelle",
    lockedEmpty:
      "Aucune — l'outil n'aurait plus de piste d'action associée.",
    lockedHint: "Changement en attente de validation : la liste proposée est affichée et ne peut pas être modifiée.",
    add: "Ajouter des pistes d'action",
    hint:
      "Pistes d'action associées à cet outil, dans l'ordre du questionnaire. L'ordre d'affichage des outils se règle par piste d'action.",
    empty: "Aucune piste d'action associée pour l'instant.",
    remove: "Retirer",
    modalTitle: "Ajouter des pistes d'action",
    searchActions: "Rechercher une piste d'action…",
    allIssues: "Tous les enjeux",
    allGoals: "Tous les objectifs",
    searchIssue: "Rechercher un enjeu…",
    searchGoal: "Rechercher un objectif…",
    selectAll: "Tout sélectionner",
    confirm: "Confirmer la sélection",
    linkedTag: "associée",
    matchCount_one: "{{count}} piste d'action",
    matchCount_other: "{{count}} pistes d'action",
    selectedCount_one: "{{count}} sélectionnée",
    selectedCount_other: "{{count}} sélectionnées",
    noMatch: "Aucune piste d'action ne correspond.",
  },
};
